import React from 'react';
import Modal, { closeStyle } from 'simple-react-modal';
import { observer } from 'mobx-react';
import './TippingModal.css';
import { Checkbox, FormControl, FormControlLabel, RadioGroup } from '@material-ui/core';
import qs from 'qs';

import { RootStoreContext } from '../../context';
import callApi from '../../utils/callApi';
import { LIST_EPAY_PACKAGES_GIFT } from '../../constants/apiUrls/apiUrls';
import AccountPackages from '../accountComponents/AccountPackages';
import PayPerViewStore from '../../store/PayPerViewStore';
import NotificationStore from '../../store/NotificationStore';
import { setProcessorForUser } from '../paymentComponents/PaymentUtils';


@observer
class TippingModal extends React.Component {

  static contextType = RootStoreContext;
  constructor(props) {
    super(props);
    this.state = {
      packages: [],
      feeIsAdded: false,
      selectedAnchor: null,
    };

    this.queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  }

  componentWillMount() {
    this.fetchPackages();
  }

  fetchPackages = () => {
    const data = {};
    if (this.props.user.authenticated) {
      const { username } = this.props.user.user;
      const token = sessionStorage.getItem('token');
      data.token = token;
      data.userName = username;
    }
    callApi(LIST_EPAY_PACKAGES_GIFT, 'get', data, {}, {}, false).
      then((res) => {
        if (res.data.status !== 'ERROR') {
          if (res.data.products?.[0]?.details?.fee) {
            this.setState({
              packages: res.data.products,
              feeIsAdded: true,
            });
            this.checkIfTipPaymentFailedAndRetry();

            return;
          }
          this.setState({ packages: res.data.products });
          this.checkIfTipPaymentFailedAndRetry();
        }
      }).
      catch((e) => console.error(e));
  };

  checkIfTipPaymentFailedAndRetry = () => {
    const { tippingStore: { setTippingModal } } = this.context;
    const { productType1, opStatus, subCategory, processorId } = this.queryParams;
    const { user } = this.props;
    if (opStatus === 'FAILED' && productType1 === 'GIFT' && subCategory) {
      setProcessorForUser(user, processorId);
      NotificationStore.error('There was a problem with payment. Please try again!');
    }
  };

  render() {
    const { tippingStore: { showTippingModal, closeTippingModal, anchor, anchorShortUrl, spotlightAnchor } } = this.context;
    const { packages, feeIsAdded, selectedAnchor } = this.state;

    return (
      <Modal
        className="test-class" // this will completely overwrite the default css completely
        closeOnOuterClick={true}
        containerClassName="test"
        show={showTippingModal}
        onClose={closeTippingModal}
      >
        <a style={closeStyle} onClick={closeTippingModal}>X</a>
        <div className="tipping-container">
          <div className="title">Tip Anchor</div>
          {
            spotlightAnchor.id ? (
              <>
                <div className="subtitle m-bot">Select anchor</div>
                <FormControl
                  className="anchor-select-container"
                  component="fieldset"
                >
                  <RadioGroup>
                    <FormControlLabel
                      key={this.context.tippingStore.anchor.id}
                      className="anchor-select-form"
                      control={
                        <Checkbox
                          checked={this.context.tippingStore.anchor.id === selectedAnchor || !selectedAnchor}
                        />
                      }
                      label={this.context.tippingStore.anchor.name}
                      value={this.context.tippingStore.anchor.id}
                      onChange={(e) => this.setState({ selectedAnchor: parseInt(e.target.value, 10) })}
                    />
                    <FormControlLabel
                      key={spotlightAnchor.id}
                      className="anchor-select-form"
                      control={
                        <Checkbox
                          checked={spotlightAnchor.id === selectedAnchor}
                        />
                      }
                      label={spotlightAnchor.name}
                      value={spotlightAnchor.id}
                      onChange={(e) => this.setState({ selectedAnchor: parseInt(e.target.value, 10) })}
                    />
                  </RadioGroup>
                </FormControl>
                <div className="subtitle m-bot">Select amount</div>
              </>
            ) : (
              <>
                <div className="subtitle">Do you want to thank {anchor.name} for her show?</div>
                <div className="subtitle m-bot">Tip her now!</div>
              </>
            )
          }

          {packages.length > 0 ? (
            <AccountPackages
              activeCampaign={{}}
              anchorShortUrl={anchorShortUrl}
              anchorToSubscribe={selectedAnchor ? selectedAnchor.toString() : this.context.tippingStore.anchor.id.toString()}
              closeTipping={closeTippingModal}
              disableOneClickPaysafe={false}
              feeIsAdded={feeIsAdded}
              isGift={true}
              programs={packages}
              returnPath={`${window.location.pathname}`}
              user={this.props.user}
            />
          ) : (<div className="subtitle" >No tipping options currently available. Try again later.</div>)}
        </div>
      </Modal>
    );
  }
}

export default TippingModal;
